import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — white marble floor. Same 1x1 m / 0.06-thick slab convention as
// floor-wood; two thin pale-grey veining strips run at slight angles.
const MARBLE = "#ece9e2";
const VEIN = "#c9c9c4";

export const floorMarble = defineModel({
  id: "floor-marble",
  batchId: "modern",
  name: "Marble floor",
  tags: ["modern", "interior", "structure", "floor", "marble"],
  summary: "A 1x1 white marble floor tile with pale veining.",
  description:
    "A one-tile white marble slab of the Modern Living kit: exactly 1x1 m " +
    "and 0.06 m thick, off-white with two thin pale-grey veining strips at " +
    "slight angles. Tiles seamlessly against every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: MARBLE, position: [0, 0.03, 0] },
      // Two veining strips, flush overlays at slight angles to the grid.
      {
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.02),
        color: VEIN,
        position: [0, 0.06, -0.22],
        rotation: [0, 0.28, 0],
      },
      {
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.018),
        color: VEIN,
        position: [0.05, 0.06, 0.24],
        rotation: [0, -0.2, 0],
      },
    ];
  },
  animations: [],
});
